

import { SkipBackIcon, SkipForwardIcon } from '../icons/NavigationIcons';
import ControlButton from '../ControlButton';

interface SkipButtonProps {
  direction: 'previous' | 'next';
  onClick: () => void;
  isMobile: boolean;
}

const SkipButton = ({
  direction,
  onClick,
  isMobile
}) => {
  // Simplify the event handling to ensure consistent behavior
  const handleClick = (e: React.MouseEvent) => {
    console.log(`SkipButton ${direction} clicked`);
    onClick();
  };

  return (
    <ControlButton 
      onClick={handleClick}
      ariaLabel={direction === 'previous' ? "Previous" : "Next"}
      className=""
    >
      {direction === 'previous' ? 
        <SkipBackIcon size={isMobile ? 20 : 24} /> : 
        <SkipForwardIcon size={isMobile ? 20 : 24} />
      }
    </ControlButton>
  );
};

export default SkipButton;
